import { Link } from "react-router-dom";
import type { Movie } from "@/mocks/movies";

interface MovieCardProps {
  movie: Movie;
  className?: string;
}

export default function MovieCard({ movie, className = "" }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className={`group block overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300 ${className}`}
    >
      <div className="relative aspect-[2/3] w-full overflow-hidden bg-background-200">
        <img
          src={movie.cover}
          alt={`${movie.title} 海报`}
          title={`${movie.title} - 芒果tv ${movie.channel}`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-2 top-2 rounded-md bg-primary-500 px-1.5 py-0.5 text-[11px] font-semibold text-background-50">
          {movie.score.toFixed(1)}
        </span>
        <span className="absolute right-2 top-2 rounded bg-foreground-950/60 px-1.5 py-0.5 text-[11px] font-medium text-background-50">
          {movie.year}
        </span>
      </div>
      <div className="p-3">
        <h3 className="truncate font-heading text-sm font-semibold text-foreground-950 group-hover:text-primary-600">
          {movie.title}
        </h3>
        <p className="mt-1 truncate text-xs text-foreground-500">
          {movie.cast.slice(0, 3).join(" / ")}
        </p>
        <div className="mt-2 flex flex-wrap gap-1">
          {movie.genres.slice(0, 2).map((g) => (
            <span
              key={g}
              className="rounded bg-secondary-100 px-1.5 py-0.5 text-[11px] text-secondary-700"
            >
              {g}
            </span>
          ))}
        </div>
        <p className="mt-2 truncate text-[11px] text-accent-600">{movie.updateStatus}</p>
      </div>
    </Link>
  );
}